var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNserixIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 133,
    viewBox: "0 0 148 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.74 6.4C130.82 8.92 126.17 11.99 122.07 15.7C114.39 22.64 109.89 30.42 109.89 41.24V66.16C109.89 74.99 112.65 83.6 117.79 90.78L120.34 94.34C123.96 99.4 128.67 103.62 134.24 106.39C135.34 106.94 136.43 107.41 137.51 107.79C141.34 109.14 144.44 108.85 146.52 106.41C147.89 103.4 148.22 100.05 148.22 96.41V0L135.74 6.4Z",
    fill: "url(#paint0_linear_icon)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.86 76.71C98.26 99.4 128.65 111.79 143.78 108.43V108.27C142.03 108.84 139.91 108.64 137.5 107.8C128.9 104.72 119.55 96.26 109.95 85.97L64.27 33.89C43.74 10.54 14.02 10.38 1.95996 33.35C4.57996 30.54 8.55996 29.79 13.03 31.56C24.23 35.61 46.73 60.94 67.86 76.71Z",
    fill: "url(#paint1_linear_icon)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.67 55.54L23.54 39.91C21.66 37.63 19.81 35.72 18.01 34.19C16.18 32.99 14.51 32.09 13.03 31.55C8.55 29.79 4.58 30.53 1.96 33.34C0.36 36.49 0 40.03 0 43.9V132.8L12.48 126.4C17.4 123.88 22.05 120.81 26.15 117.1C33.83 110.16 38.33 102.38 38.33 91.56V65.62C38.33 62.18 37.77 58.77 36.68 55.52L36.67 55.54Z",
    fill: "url(#paint2_linear_icon)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5298 39.9101L76.0798 102.43C85.0898 113.05 94.8898 120.81 106.26 123.04C124.38 126.41 140.3 121.37 146.66 106.24C145.86 107.24 144.89 107.9 143.78 108.26V108.42C128.64 111.78 98.2498 99.3901 67.8498 76.7001C46.7298 60.9401 24.2298 35.6101 13.0298 31.5601C16.3698 32.8801 19.9898 35.6001 23.5398 39.9101H23.5298Z",
    fill: "url(#paint3_linear_icon)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_icon",
    x1: 129.05,
    y1: -6.53,
    x2: 129.05,
    y2: 105.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4554FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_icon",
    x1: 120.1,
    y1: 112.77,
    x2: 19.75,
    y2: 21.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4554FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_icon",
    x1: 19.16,
    y1: 36.71,
    x2: 19.16,
    y2: 136.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4554FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_icon",
    x1: 4.26979,
    y1: 36.7801,
    x2: 147.66,
    y2: 130.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4554FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92FFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNserixIcon);
export default __webpack_public_path__ + "static/media/nserix-icon.003bdf976f958e3d13e4ec4e928c3c2a.svg";
export { ForwardRef as ReactComponent };